import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from "vue-loading-overlay";
import { mapGetters } from "vuex";
import axios from "axios";
import upLoad from '@/assets/img/screenshoot_upload.png';
import Select2Multiple from 'v-select2-multiple-component';
import CONFIG from "@/assets/js/config.js";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
	name: "SettingEdit",

	components: {
		MainLayout,
		Loading,
		Select2Multiple,
		flatPickr,
	},

	data() {
		return {
			time_config: {
				enableTime: true,
				noCalendar: true,
				dateFormat: "H:i",
				time_24hr: true,
			},
			isLoading: false,
			disabled: false,
			upLoad,
			isFbEnable: false,
			apiUserId: '',
			signImage: null,
			settings: {
				teacher_chat_approval: false,
				chat_file_upload_enabled: false,
				signature: null,
				send_notice_notifications: false,
				facebook_integration: false,
				use_facebook_page: false,
				currency: '',
				report_card_grading: null,
				client_type: null,
        payment_slip_size: 0,
				school_start_time: null,
				school_end_time: null,
				teacher_attendance_qr: null,
			},
			currencies: [],
			reportCardGrading: [],
			isFileChange: false,
			clientType: [],
      paymentSlipSize: CONFIG.PAYMENT_SLIP_SIZE,
		};
	},

	computed: {
		...mapGetters(["getUser"]),
	},

	methods: {
		toggleFacebookIntegration() {
			if (this.settings.facebook_integration) {
				this.isLoading = true;
				let campusId = this.$store.state.user.campus_id;
				const state = encodeURIComponent(JSON.stringify({ campus_id: campusId }));
				const clientId = process.env.VUE_APP_FACEBOOK_APP_ID;
				const redirectUri = encodeURIComponent(process.env.VUE_APP_FACEBOOK_REDIRECT_URI);
				const scope = process.env.VUE_APP_FACEBOOK_PERMISSIONS;
				const responseType = 'code'; // OAuth flow
				const fbAuthUrl = `https://www.facebook.com/v21.0/dialog/oauth?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&response_type=${responseType}&state=${state}`;
				window.location.href = fbAuthUrl;
				this.Loading = false;
				this.facebook_integration = true;
			} else {
				this.isLoading = true;
				this.isFbEnable = false;
				this.settings.facebook_integration = false;
				this.isLoading = false;
			}
		},

		async getCurrency() {
			try {
				const response = await axios.get('setting/getCurrency');
				if (response) {
					this.currencies = Object.values(response.data).map(item => ({
						id: item.code,
						text: `${item.name} (${item.currency_symbol}) - ${item.code}`
					}));
				}
			} catch (error) {
				if (error.response.status == 401) {
					this.$store.commit('logout');
					window.location.replace('login');
				}
				this.isLoading = false;
			}
		},

		async getReportCardGrading() {
			try {
				const response = await axios.get('setting/report-card-grading');
				if (response) {
					this.reportCardGrading = Object.values(response.data).map(item => ({
						id: item.value,
						text: item.name
					}));
				}
			} catch (error) {
				if (error.response.status == 401) {
					this.$store.commit('logout');
					window.location.replace('login');
				}
				this.isLoading = false;
			}
		},

		getSetting() {
			this.isLoading = true;
			axios
				.get("/setting/" + this.$store.state.user.campus_id)
				.then((response) => {
					this.settings.teacher_chat_approval = response.data.teacher_chat_approval == 1 ? true : false;
					this.settings.chat_file_upload_enabled = response.data.chat_file_upload_enabled == 1 ? true : false;
					this.settings.signature = this.signImage = response.data.signature;
					this.settings.send_notice_notifications = response.data.send_notice_notifications == 1 ? true : false;
					this.settings.use_facebook_page = response.data.use_facebook_page == 1 ? true : false;
					this.settings.currency = response.data.currency || 'MMK';
					this.settings.report_card_grading = response.data.report_card_grading || null;
					this.settings.school_start_time = response.data.school_start_time || null;
					this.settings.school_end_time = response.data.school_end_time || null;
					this.settings.teacher_attendance_qr = response.data.teacher_attendance_qr || null;
					this.settings.client_type = response.data.client_type || 'school';
          this.settings.payment_slip_size = response.data.payment_slip_size ?? 0;
					if (this.isFbEnable) {
						this.settings.facebook_integration = true;
					} else {
						this.settings.facebook_integration = response.data.facebook_integration == 1 ? true : false;
					}
					this.isLoading = false;
				})
				.catch((error) => {
					if (error.response && error.response.status == 401) {
						this.$store.commit('logout');
						window.location.replace('login');
					}
				});
		},

		getClientType() {
				this.clientType = Object.entries(CONFIG.CLIENT_TYPE).map(([key, value]) => ({
						id: key,
						text: value
				}));
		},

		saveSetting() {
			this.isLoading = true;
			this.disabled = true;
			this.settings.teacher_chat_approval = this.settings.teacher_chat_approval ? 1 : 0;
			this.settings.chat_file_upload_enabled = this.settings.chat_file_upload_enabled ? 1 : 0;
			this.settings.facebook_integration = this.settings.facebook_integration ? 1 : 0;
			this.settings.send_notice_notifications = this.settings.send_notice_notifications ? 1 : 0;
			this.settings.use_facebook_page = this.settings.use_facebook_page ? 1 : 0;
			this.settings.signature = this.signImage == null ? '' : this.signImage;
			this.settings.currency = this.settings.currency ?? null;
			this.settings.school_start_time = this.settings.school_start_time ?? null;
			this.settings.school_end_time = this.settings.school_end_time ?? null;
			this.settings.teacher_attendance_qr = this.settings.teacher_attendance_qr ?? null;
			this.settings.client_type = this.settings.client_type ?? null;
      this.settings.payment_slip_size = this.settings.payment_slip_size ?? 0;
			let request = {
				campus_id: this.$store.state.user.campus_id,
				api_user_id: this.apiUserId,
				settings: this.settings,
				file_change: this.isFileChange,
				facebook_integration: this.facebook_integration,
			};
			axios
				.post("/setting/save", request)
				.then((response) => {
					if (response.data.success) {
						this.$store.commit('setChatApproval', this.settings.teacher_chat_approval);
						this.$store.commit('setChatFileUploadEnabled', this.settings.chat_file_upload_enabled);
						this.$store.commit('setClientType', this.settings.client_type);
						this.$store.commit('updateCurrency', this.settings.currency);
						this.$router.push({ name: 'settingPage' });
					}
					this.isLoading = false;
					this.disabled = false;
				})
				.catch((error) => {
					if (error.response && error.response.status == 401) {
						this.$store.commit('logout');
						window.location.replace('login');
					}
					if (error.response && error.response.status == 422) {
                        this.$notification.error(error.response.data.message, {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    }
					this.isLoading = false;
                    this.disabled = false;
				});
		},

		chooseFiles(id) {
			document.getElementById(id).click();
		},

		onFileChange(e) {
			var selectedFile = e.target.files[0];

			if (selectedFile.type !== "image/png") {
				this.$notification.error("Only PNG file type allowed!", {
					timer: 3,
					position: "bottomCenter",
				});
				return null;
			}

			if (selectedFile.size > CONFIG.IMAGE_MAX_FILE_SIZE) {
				this.$notification.error(CONFIG.IMAGE_MAX_SIZE_ERROR, {
					timer: 3,
					position: "bottomCenter",
				});
				return null;
			}

			let reader = new FileReader();
			reader.readAsDataURL(selectedFile);
			reader.onloadend = () => this.$set(this, "signImage", reader.result);
			this.isFileChange = true;
		},

		removeImg(img) {
			this.$set(this, "signImage", null);
			document.getElementById(img).value = '';
			this.isFileChange = true;
		},

		generateAttendanceQR() {
			if (window.confirm("If you generate new QR, the previous QR cannot be used anymore. Are you sure want to generate new QR?")) {
				let qr = this.$store.state.user.campus_id;
				const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
				const charsLength = chars.length;
				for (let i = 0; i < 12; i++) {
					qr += chars.charAt(Math.floor(Math.random() * charsLength));
				}
				this.settings.teacher_attendance_qr = qr;
			}
		}
	},

	mounted() {
		this.getSetting();
		this.getCurrency();
		this.getReportCardGrading();
		this.getClientType();
		const urlParams = new URLSearchParams(window.location.search);
		const fb_enable = urlParams.get('fb-enable');
		const apiUserId = urlParams.get('api-user-id');
		if (fb_enable) {
			this.apiUserId = apiUserId;
			this.isFbEnable = true;
		}
	}
}
